import React, { Dispatch, useEffect, useRef } from 'react';


const usePasteFile = <T extends HTMLElement>(callback: Dispatch<React.SetStateAction<File[]>>, accept: string[]|null = null) => {
    const inputRef = useRef<T>(null);

    useEffect(() => {
        if (!inputRef.current) return;

        inputRef.current.onpaste = (event) => {
            if (!event.clipboardData) return;

            const files: File[] = [];

            for (const item of event.clipboardData.items) {
                if (item.kind === 'file') {
                    let allow = !accept;

                    if (accept) {
                        for (const type of accept) {
                            if (item.type.includes(type))
                                allow = true;
                        }
                    }

                    if (allow)
                        files.push(item.getAsFile()!)
                }
            }

            if (!files.length) return;

            callback(old => [...old, ...files]);
        }
        // eslint-disable-next-line
    }, [inputRef, callback]);

    return inputRef;
};

export default usePasteFile;
